<div class="div_manager_emp">
  <div class="pos-title-header">
    <label class="lbl_top align-middle">{{'MANAGER_EMPLOYEES.EMPLOYEES_SCHEDULING' | translate}}</label>
  </div>
  <div class="pos-description-header">
    <label>{{'MANAGER_EMPLOYEES.MANAGE' | translate}}</label>
  </div>
    <div class="manager_employees_container">
      <div class="inner_container">
        <div class="calendar_buttons pt-4 pe-4 d-flex flex-row items_center justify-content-between">
          <div class="d-flex">
            <span>{{'MANAGER_EMPLOYEES.WEEKLY' | translate}}</span>
            <button type="button" class="prev-next-btn" (click)="prevWeek()"><i class="pi pi-angle-left"></i></button>
            <button type="button" class="prev-next-btn" (click)="nextWeek()"><i class="pi pi-angle-right"></i></button>
          </div>
          <div class="d-flex">
            <button type="button" class="today-btn me-3" (click)="goToToday()">{{'MANAGER_EMPLOYEES.TODAY' | translate}}</button>
            <p-calendar class="month-year-picker" (ngModelChange)="goToDate($event)" [(ngModel)]="selectedMonthYear"
                        view="month" dateFormat="mm/yy" [yearNavigator]="true" yearRange="2000:2100"
                        [readonlyInput]="true" inputId="monthpicker"></p-calendar>
          </div>
        </div>
        <div class="manager_employees_table">
          <div class="w-100 mb-4">
            <div class="d-inline-block w-15"></div>
            <div class="d-inline-block w-85">
              <full-calendar [options]="headerCalendarOptions"></full-calendar>
            </div>
          </div>
          <div class="w-100 employees_calendars">
            <div *ngFor="let employee of listAllEmployees; index as index" class="employee_card">
              <div class="w-100">
                <div class="d-inline-block w-15">
                  <div class="d-flex flex-row items_center">
                    <img class="employee_picture_list"
                         [src]="employee.pictureUrl ? employee.pictureUrl : imagePath"
                         alt="profile-picture">
                    <div class="employee_info" title="{{employee.firstName + ' ' + employee.lastName}}">
                      <h5 class="hide_mobile title"><span>{{employee.firstName}}
                            </span><span>{{employee.lastName}}</span></h5>
                      <h5 class="show_mobile title"><span>{{employee.firstName[0]}}
                            </span><span>{{employee.lastName[0]}}</span></h5>
                      <div class="employee_role">
                        <span class="hide_mobile"> {{('MANAGER_EMPLOYEES.' + EmployeeRoleEnum[employee.venueEmployeeTypeId].toUpperCase() | translate) | lowercase}} </span>
                        <span class="show_mobile"> {{('MANAGER_EMPLOYEES.' + EmployeeRoleEnum[employee.venueEmployeeTypeId].toUpperCase() | translate)[0] | uppercase}} </span>
                      </div>
                    </div>
                    <div>
                      <i class="pi pi-ellipsis-v spam-menu manager-emp-menu" (click)="menu.toggle($event)"></i>
                      <p-menu #menu class="edit-menu header-menu" [popup]="true" [model]="items[employee.id]"></p-menu>
                    </div>
                  </div>
                </div>
                <div class="d-inline-block w-85">
                  <full-calendar [options]="options[employee.id]"></full-calendar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<p-confirmPopup styleClass="logout-confirm-popup"></p-confirmPopup>
